import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_BASE_URL from '../config';
import { ClipLoader } from 'react-spinners';

const PrivacyPolicySection = () => {
  const [privacyData, setPrivacyData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPrivacyPolicyData();
  }, []);

  const fetchPrivacyPolicyData = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}home/info`);

      if (response.data.success) {
        setPrivacyData(response.data.data);
      } else {
        setError("Failed to fetch privacy policy information");
      }
    } catch (err) {
      setError("Error fetching privacy policy information");
      console.error("API Error:", err);
    } finally {
      setLoading(false);
    }
  };

  // Loading state
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100%",
        }}
      >
        <ClipLoader size={45} />
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <section className="about-section py-5">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <>
      <section className="innerbanner"></section>

      <section className="staticpagecontainer">
        <div className="container">
          <div className="row">
            <div className="col-12">
              {privacyData?.privacy_policy ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: privacyData.privacy_policy,
                  }}
                />
              ) : (
                <div className="text-center">
                  <p className="text-muted">
                    No privacy policy content available yet.
                  </p>
                  <p>
                    We are committed to protecting your privacy and ensuring
                    transparency in how your personal information is collected,
                    used, and safeguarded.
                  </p>
                  <p>
                    Please check back later for detailed privacy policy
                    information regarding data usage, cookies, payments, and
                    user rights.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicySection;
